// Mirrors the backend sanitizer (LeadG.BAL/Helper/FileNameHelper.cs) so a downloaded
// filename is stripped identically on both ends — keep the two in sync if this changes.
const INVALID_FILE_NAME_CHARS = /[\\/:*?"<>|]/g;
export const sanitizeFileName = (value) => {
    if (!value) {
        return "";
    }
    return value.replace(INVALID_FILE_NAME_CHARS, "").trim();
};
